import 'angular-gridster'

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { default as commonModule } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { UserSession, ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { default as SERVICES_MODULE_NAME } from './../../services/services.module'
import { PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'

import { GroupingLocationTypeController, GroupingLocationTypeScope } from './grouping-locations-types.controller'
import { GroupingLocationTypeCreateEditDirective } from './create-edit/grouping-locations-types-create-edit.directive'
import { GroupingLocationTypeDetailsDirective } from './details/grouping-locations-types-details.directive'

import { GroupingLocationTypeHelper } from './grouping-locations-types.helper'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../services/user-session'
import { StateProvider, StateService } from '@uirouter/angularjs'

//#region Asset Imports

import * as TEMPLATE from './grouping-locations-types.tpl.html'

//#endregion

// Consts

const CONTROLLER_NAME: string = 'GroupingLocationTypeController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'groupingLocationTypeCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'groupingLocationTypeDetails'
const MODULE_NAME: string = 'simax.grouping-locations-types'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'GROUPING_LOCATION_TYPE_NAME'
const STATE_NAME: string = 'groupingLocationsTypes'
const STATE_URL: string = '/groupingLocationsTypes'

// Consts End


// Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [$SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'api', 'localDictionary', USER_SESSION_SERVICE_NAME, SYSTEM_SERVICE_NAME, (
    $scope: GroupingLocationTypeScope,
    $state: StateService,
    $timeout: ng.ITimeoutService,
    api: Api,
    localDictionary: LocalDictionaryFactory,
    userSession: UserSessionService,
    systemService: SystemService
) => new GroupingLocationTypeController(
    $scope,
    $state,
    $timeout,
    api,
    localDictionary,
    userSession,
    systemService,
    GroupingLocationTypeHelper.REFERENCE_TYPE,
    GroupingLocationTypeHelper.SIMAX_MODULE_NAME
)])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new GroupingLocationTypeDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new GroupingLocationTypeCreateEditDirective()])

module.config(['$stateProvider', 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Grouping_Location_Type_IdLocationType',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.GROUPING_LOCATION_TYPE_LIST)
                && !loggedOperator.hasPermission(Activity.GROUPING_LOCATION_TYPE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.GroupingLocationTypeModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.LOCATION_TYPE),
                    'groupingLocationsTypes',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End


export default MODULE_NAME